import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import Button from 'shared/ui/Button';
import Modal from 'shared/ui/Modal';
import './NotesModal.css';

const NotesModal = ({ isOpen, onClose, fanId, subscriptionId }) => {
    const [notes, setNotes] = useState('');
    const [initialNotes, setInitialNotes] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    
    const userId = fanId;

    const fetchNotes = useCallback(async () => {
        if (!isOpen || !fanId) return;
        setIsLoading(true);
        try {
            const jwt = Cookies.get('user_token');
            const response = await axios.post('https://unbot.io/api/v1.0/proxy', {
                method: 'GET',
                path: 'v2.0/users/notes',
                parameters: { userId: fanId },
                subscriptionId: subscriptionId,
            }, {
                headers: { Authorization: `Bearer ${jwt}` },
            });

            if (response.data && response.data.comment) {
                const fetchedNotes = response.data.comment;
                setNotes(fetchedNotes);
                setInitialNotes(fetchedNotes);
            } else {
                setNotes('');
                setInitialNotes('');
            }
        } catch (error) {
            console.error('Error fetching notes:', error);
            setNotes('');
            setInitialNotes('');
        } finally {
            setIsLoading(false);
        }
    }, [isOpen, fanId, subscriptionId]);

    useEffect(() => {
        fetchNotes();
    }, [fetchNotes]);

    const handleSave = async () => {
        setIsSaving(true);
        try {
            const jwt = Cookies.get('user_token');
            await axios.post('https://unbot.io/api/v1.0/proxy', {
                method: 'PUT',
                path: 'v2.0/users/notes',
                parameters: {
                    userId: userId,
                    comment: notes,
                },
                subscriptionId: subscriptionId,
            }, {
                headers: { Authorization: `Bearer ${jwt}` },
            });
            setInitialNotes(notes);
            onClose(); 
        } catch (error) {
            console.error('Error saving notes:', error);
        } finally {
            setIsSaving(false);
        }
    };
    
    useEffect(() => {
        if (!isOpen) {
            setNotes('');
            setInitialNotes('');
        }
    }, [isOpen]);

    const hasChanged = notes !== initialNotes;

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Notes sur l'utilisateur"
            overlayClassName="notes-modal-overlay"
            panelClassName="notes-modal-content open"
            headerClassName="notes-modal-header"
            bodyClassName="notes-modal-body"
            footerClassName="notes-modal-footer"
            closeButtonClassName="notes-modal-close-btn"
            footer={(
                <Button onClick={handleSave} disabled={isSaving || !hasChanged}>
                    {isSaving ? 'Enregistrement...' : 'Enregistrer'}
                </Button>
            )}
        >
            {isLoading ? (
                <p>Chargement des notes...</p>
            ) : (
                <textarea
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    placeholder="Ajoutez des notes sur cet utilisateur..."
                />
            )}
        </Modal>
    );
};


export default NotesModal;
